<template>
  <div class="weui-cell weui-cell_access" @click="select">
    <div class="weui-cell__hd">
      <label for class="weui-label">{{ label }}</label>
    </div>
    <div class="weui-cell__bd">{{ value }}</div>
    <div class="weui-cell__ft">
      <span v-show="!value">请选择</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    value: String,
  },
  methods: {
    select() {
      var me = this,
        date = me.value ? new Date(me.value.replace(/-/g, "/")) : new Date(),
        hour = date.getHours(),
        hours = [],
        minute = date.getMinutes(),
        minutes = [],
        i,
        len;
      for (i = 0, len = 23; i <= len; i++) {
        hours.push({
          value: i,
          label: i + "时",
        });
      }
      for (i = 0, len = 3; i <= len; i++) {
        minutes.push({
          value: i * 15,
          label: i * 15 + "分",
        });
      }
      me.$weui.picker(hours, minutes, {
        defaultValue: [hour, minute],
        onConfirm: function (r) {
          var val = r[0].value + ':' + (r[1].value ? r[1].value : '00');
          me.$emit("input", val);
          me.$emit("selected")
        },
      });
    },
  },
};
</script>